<!-- eslint-disable vue/no-v-html -->
<template>
  <ThePopUp
    :is-open="isShowPopUp"
    :mask-closable="false"
    :min-height="'auto'"
    @close="handleClose"
  >
    <div class="py-2 tablet:px-2">
      <div class="relative mb-5">
        <strong class="block pr-6 text-2xl">
          {{ t('title') }}
        </strong>
        <button class="absolute right-0 top-1 h-6 w-6" @click="handleClose">
          <IconClose class="h-full w-full text-black" />
        </button>
      </div>
      <div class="w-full">
        <div class="mb-8 text-base text-gray-600">
          <p class="mb-5">{{ t('description') }}</p>
          <ul class="element-content list-disc pl-7">
            <li class="mb-3">{{ t('content-1') }}</li>
            <li v-html="t('content-2', { mail: HTML_TAG_MAIL })" />
          </ul>
        </div>
        <TheButton
          :to="`/${locale}/marketplace/help/sales-support?IssueType=0`"
          :title="t('contact-us')"
          class="block w-full"
          @click="handleClose"
        >
          <span class="text-sm">{{ t('contact-us') }}</span>
        </TheButton>
      </div>
    </div>
  </ThePopUp>
</template>

<script setup lang="ts">
  const emits = defineEmits<{ (e: 'close'): void }>();

  const { t, locale } = useI18n({ useScope: 'local' });
  const mainStore = useMainStore();
  const { loginState } = storeToRefs(mainStore);

  const isShowPopUp = computed((): boolean => loginState.value.isFailed);

  const HTML_TAG_MAIL = ref<string>(
    '<a href="mailto:WISE-Marketplace@advantech.com" title="WISE-Marketplace@advantech.com">WISE-Marketplace@advantech.com</a>'
  );

  const handleClose = (): void => {
    loginState.value.isFailed = false;
    emits('close');
  };
</script>

<style lang="scss" scoped>
  .element-content:deep(a) {
    @apply text-blue-400;

    &:hover {
      @apply underline;
    }
  }
</style>

<i18n lang="json">
{
  "en-int": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-jp": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-tw": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-kr": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-americas": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-asia-pacific": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "en-emea": {
    "title": "Sorry, your account cannot log in.",
    "description": "You can seek assistance through following methods:",
    "content-1": "Have the highest authority WISE account in your company add you to \"My Team\".",
    "content-2": "Email to {mail} or use \"Contact Us\" to report login issue, we will assist you as soon as possible.",
    "contact-us": "Contact Us"
  },
  "ja-jp": {
    "title": "申し訳ありませんが、お客様のアカウントではログインできません。",
    "description": "問題を解決するには、以下の手順を実行してください。",
    "content-1": "お客様の会社の最高権限を持つ WISE アカウントに「マイチーム」に追加してもらってください。",
    "content-2": "{mail} にメールを送信するか、「お問い合わせ」からログインできない問題を報告してください。できるだけ早くサポートさせていただきます。",
    "contact-us": "お問い合わせ"
  },
  "zh-cn": {
    "title": "抱歉，您的账户无法登录。",
    "description": "采取以下方式解决您的问题：",
    "content-1": "请贵公司最高权限的研华工业云账户将您加入「我的团队」。",
    "content-2": "请寄信到 {mail} 或是「联系我们」报告您遇到无法登录的问题，我们将尽快协助您。",
    "contact-us": "联系我们"
  },
  "zh-tw": {
    "title": "抱歉，您的帳戶無法登入。",
    "description": "您可以透過以下方式尋求協助：",
    "content-1": "請貴公司最高權限的 WISE 帳戶將您加入「我的團隊」。",
    "content-2": "請寄信到 {mail} 或是「聯繫我們」回報問題您遇到無法登入的問題，我們將盡快協助您。",
    "contact-us": "聯繫我們"
  }
}
</i18n>
